import { Controller } from "@hotwired/stimulus";

const WORDS = [
  "Brewing",
  "Buffing",
  "Churning",
  "Cooking",
  "Defoaming",
  "Detailing",
  "Finagling",
  "Flushing",
  "Foaming",
  "Glazing",
  "Herding",
  "Honking",
  "Hustling",
  "Lathering",
  "Lubricating",
  "Marinating",
  "Misting",
  "Moseying",
  "Percolating",
  "Polishing",
  "Pre-soaking",
  "Pressurizing",
  "Processing",
  "Puttering",
  "Reclaiming",
  "Rinsing",
  "Schlepping",
  "Scrubbing",
  "Simmering",
  "Smooshing",
  "Spinning",
  "Spritzing",
  "Squeegeeing",
  "Stewing",
  "Sudsing",
  "Titrating",
  "Transmuting",
  "Tri-Foaming",
  "Vacuuming",
  "Vibing",
  "Waxing",
  "Working",
];

export default class extends Controller {
  static targets = ["word"];
  static outlets = ["admin--massimo--chat-submit"];

  connect() {
    this.queue = [];
    this.stopping = false;
    this.showNext();
  }

  adminMassimoChatSubmitOutletConnected(outlet) {
    if (outlet.stopping) this.enterStopping();
  }

  enqueue(event) {
    const description = event.detail?.description;
    if (!description) return;
    const last = this.queue[this.queue.length - 1] ?? this.lastShown;
    if (description === last) return;
    this.queue.push(description);
  }

  enterStopping() {
    this.stopping = true;
    this.wordTarget.textContent = "Stopping...";
    this.lastShown = "Stopping";
  }

  showNext() {
    if (this.stopping) return;
    const next = this.queue.shift() ?? this.randomWord();
    this.wordTarget.textContent = `${next}...`;
    this.lastShown = next;
  }

  randomWord() {
    let word;
    do {
      word = WORDS[Math.floor(Math.random() * WORDS.length)];
    } while (word === this.lastShown);
    return word;
  }
}
